import React from 'react';

import { Form } from 'ctm-components';
import { pageContext } from 'ctm-util-functions';

/**
 * @desc Builds a form for a given page based on the supplied JSON schema.
 */
class FormBuilder {

    /**
     * @desc Builds the form for a page by creating each top level form component
     * @param {String} formPageName - The name of the form page to build
     * @param {Object} extraProps - Any additional props - these are used when the form is defined as a component - see HnC callMeBackForm
     * @returns {Node} - The form for the specified page.
     */
    build = (formPageName, extraProps = {}) => {
        const schemaModel = pageContext.getProps().models.formSchemaModel;
        const formPageSchema = schemaModel.getPage(formPageName);

        const parsedExtraProps = Object.keys(extraProps).reduce((acc, key) => {
            if (key.includes('Props')) {
                acc[key] = extraProps[key];
            }
            return acc;
        }, {});

        return (
            <Form schema={formPageSchema} key={`${formPageName}_form`} extraProps={parsedExtraProps} />
        );
    };

}

export { FormBuilder };
